import React, { Component } from "react";
import { connect } from "react-redux";
import config from "config/api";
import Paragrapher from "components/UI/Paragrapher";
import Header from "components/Header/Header";
import Footer from "components/Footer";
import ScrollToTopOnMount from "components/UI/ScrollToTopOnMount";
import BlockTitle from "components/UI/BlockTitle";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { withStyles } from "@material-ui/core/styles";

import {
  fetchData,
  getDataLegal,
  getLoadingError,
} from "../../ducks/asyncFetcher";

const styles = (theme) => {
  return {
    root: {
      "& .MuiTypography-h5": {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
      },
    },
    paper: {
      padding: "10px 20px",
      maxWidth: "1024px",
      margin: "0 auto 20px",
      textAlign: "left",
    },
  };
};

const AF_KEY = "legal";

class Legal extends Component {
  componentDidMount() {
    this.props.onMount();
  }
  render() {
    const { $$data: $$legal, classes } = this.props;

    return (
      <div className="home">
        <ScrollToTopOnMount />
        <Header current={false} condensed={true} />
        <div id="legal" className={classes.root}>
          <Choose>
            <When condition={$$legal !== undefined}>
              <ScrollToTopOnMount />
              <div className="legalWrapper">
                <Box align="middle" mt={4} mb={8} width="100%">
                  <Typography variant="h2" gutterBottom>
                    {$$legal.get("title")}
                  </Typography>
                </Box>
                <Paper classes={{ root: classes.paper }}>
                  <div className="content">
                    <Paragrapher
                      prettyfy={true}
                      text={$$legal.get("content")}
                      transformBullets={false}
                    />
                  </div>
                </Paper>
              </div>
            </When>
            <Otherwise>
              <div>LOADING !!</div>
            </Otherwise>
          </Choose>
        </div>
        <Footer style={{ zIndex: 189, marginTop: -10 }} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataLegal(state),
    error: getLoadingError(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.legal }));
    },
  };
}
export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Legal)
);



// WEBPACK FOOTER //
// ./src/components/Legal/Legal.jsx